module.exports = __webpack_public_path__ + "static/media/Sachin Lotankar.e8dbbf4e.png";